import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard. Two modes (don't combine):
 *  - ``requireRole`` (string or array) — allow only the listed role(s).
 *  - ``denyRoles`` (string or array) — allow everyone EXCEPT the listed role(s).
 *
 * When access is denied, sellers are sent to ``/mi-desempeno`` (their home),
 * everyone else lands on ``/dashboard``. Server-side RBAC is the source of
 * truth; this layer just prevents the empty-shell UX where a seller sees a
 * broken page because every fetch returns 403.
 */
export default function ProtectedRoute({ children, requireRole, denyRoles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando...</div>;
  if (!user) return <Navigate to="/" replace />;
  const role = user.role_type;
  const inList = (x, v) => (Array.isArray(x) ? x.includes(v) : x === v);
  const fallback = role === 'vendedor' ? '/mi-desempeno' : '/dashboard';
  if (requireRole && !inList(requireRole, role)) {
    return <Navigate to={fallback} replace />;
  }
  if (denyRoles && inList(denyRoles, role)) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
